/**
 * 招待コードの日本語（en.invite.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。表記の決め事は ja.ts の冒頭と同じ。
 * 言葉は Money の最終案のまま:「招待クレジット（利用料だけに使えます・返金や出金はできません）」「うち招待クレジット {remaining}」「メールの確認が済むと入ります」
 */
import type { enInvite } from './en.invite';
import type { PluralMsg } from './index';

type InviteMessages = { [K in keyof typeof enInvite]: (typeof enInvite)[K] extends string ? string : string | PluralMsg };

export const jaInvite: InviteMessages = {
  'invite.field': '招待コード',
  'invite.card.title': '招待クレジット',
  'invite.card.lead': '招待クレジットは利用料だけに使えます。返金や出金はできません。',
  'invite.card.label': '招待コード',
  'invite.card.submit': '招待コードを入れる',
  'invite.card.pending': '招待クレジット {amount} は、届いたメールのリンクを開いてメールアドレスを確かめると入ります。',
  'invite.card.credited': 'うち招待クレジット 残り {amount} / {granted}（利用料だけに使えます・出金はできません）',
  'invite.card.done': '招待コードを使いました。招待クレジット {amount} が入りました。',
  'invite.card.donePending': '招待コードを受け付けました。招待クレジット {amount} は、届いたメールのリンクを開いてメールアドレスを確かめると入ります。',
  'invite.ignored.title': 'ログインしました',
  'invite.ignored.body': 'このメールアドレスのアカウントはもうあったので、そのままログインしました。招待コードはまだ使っていません。招待コードは「お金 → 前払い残高」の画面で入れられます。',
  'error.invalid_invite_code': 'この招待コードは使えません。打ち間違いがないか確かめてください（できればもう一度コピーしてください）。',
  'error.invite_code_expired': 'この招待コードは期限が終わりました。新しいコードを探すか、教えてくれた人に聞いてください。',
  'error.invite_code_used_up': 'この招待コードは使える人数に達しました。新しいコードを探すか、教えてくれた人に聞いてください。',
  'error.invite_code_used': 'この招待コードは既に使われています。コードは 1 回だけ使えます。渡してくれた人に新しいコードをもらってください。',
  'error.invite_limit_reached': '招待クレジットは配り終わったため、このコードはもう使えません。カードでの入金はいつでもできます。',
  'invite.inviteOnly': '{product} は今は招待制です。アカウントを作るには招待コードが要ります。',
  'error.invite_code_required': 'アカウントを作るには招待コードが要ります。招待コードの欄に入れてから、メール・Google・GitHub のどれかでアカウントを作ってください。',
  // 2026-10-18 gtm/early-fixes（WHY は en.invite.ts）
  'invite.adReady': '招待コードはもう入っています。アカウントを作ると{amount}のクレジットが入ります（Google か GitHub ならすぐ・メールなら確認のあと）。',
  'invite.adReadyCredit': '招待コードはもう入っています。アカウントを作ると招待クレジットが入ります（Google か GitHub ならすぐ・メールなら確認のあと）。',
  'invite.earlyFull': 'このリンクの枠は埋まりました。来てくださってありがとうございます。このリンクからの先行アクセスの枠はすべて使われました。',
  'error.already_redeemed': 'このアカウントは既に招待コードを使っています。招待コードは 1 アカウントにつき 1 回だけです。',
  'invite.notApplied.title': 'アカウントができました',
  // 2026-10-29 core/open-signup-polish（WHY は en.invite.ts）。日本語は文の間に空白を入れない
  'invite.notApplied.body': '{lead}{tail}',
  'invite.notApplied.lead.invalid': 'その招待コードは見つからなかったので、クレジットは入っていません。',
  'invite.notApplied.lead.ended': 'その招待コードは期限が終わっていたので、クレジットは入っていません。',
  'invite.notApplied.lead.used': 'その招待コードは既に使われていたので、クレジットは入っていません。',
  'invite.notApplied.lead.full': 'その招待コードは使える人数に達していたので、クレジットは入っていません。',
  'invite.notApplied.lead.earlyFull': 'このリンクの先行アクセスの枠は埋まっていたので、クレジットは入っていません。',
  'invite.notApplied.lead.limit': '招待クレジットは配り終わっていたので、クレジットは入っていません。',
  'invite.notApplied.lead.other': 'その招待コードは使えなかったので、クレジットは入っていません。',
  'invite.notApplied.tail.code': '別のコードは、あとで「お金 → 前払い残高」の画面から入れられます。',
  'invite.notApplied.tail.card': '入金は「お金 → 前払い残高」の画面からいつでもできます。',
  'invite.notApplied.billing': '前払い残高を開く',
  'invite.haveCode': '招待コードがあれば入れる',
  'error.disposable_email': '使い捨てのメールアドレスのようです。ふだん使い続けるメールアドレスで登録してください。'
};
